const LAST_ALERT_SHOWN_LOCALSTORAGE_KEY = "PageConnectionMonitor_LastAlertShown_";
const REQUEST_TIMINGS_LOCALSTORAGE_KEY = "PageConnectionMonitor_Timings_";

const ANALYSIS_REQUEST_NUMBER = 10;

var PageConnectionMonitor = function () {

};

PageConnectionMonitor.init = function () {
    if (Benner.Page.useConnectionMonitor == null || Benner.Page.useConnectionMonitor == false) {
        return;
    }

    if (shouldShowAlert()) {
        var options = {
            "positionClass": "toast-bottom-right",
            "showDuration": "4000",
            "hideDuration": "4000",
            "timeOut": "10000",
            "toastClass": "toastr-unstable-network-connection"
        };
        toastr.error("Notamos uma instabilidade de comunicação com a internet. Isso pode gerar lentidão no sistema.", "Conexão instável", options)
        setLastShownInLocalStorage();
        clearRequestTimingsFromLocalStorage();
    }
}

PageConnectionMonitor.getRequestNetworkTimingInMs = function () {
    var requestNetworkPreTiming = calculateTimings('navigationStart', 'requestStart');
    var requestNetworkPostTiming = calculateTimings('responseStart', 'responseEnd');
    var requestNetworkTiming = requestNetworkPreTiming + requestNetworkPostTiming;
    return requestNetworkTiming;
};

PageConnectionMonitor.getRequestServerTimingInMs = function () {
    var requestServerTiming = calculateTimings('requestStart', 'responseStart');
    return requestServerTiming;
}

PageConnectionMonitor.getRequestBrowserTimingInMs = function () {
    var requestBrowserTiming = calculateTimings('responseEnd', 'loadEventEnd');
    return requestBrowserTiming;
}

function calculateTimings(startIndex, finishIndex) {
    var timingsRaw = (window.performance
        || window.mozPerformance
        || window.msPerformance
        || window.webkitPerformance
        || {}).timing;

    if (timingsRaw == null) {
        return null;
    }

    return timingsRaw[finishIndex] - timingsRaw[startIndex];
}

function shouldShowAlert() {
    const isRequestAfterLogin = document.referrer != null && (document.referrer.endsWith("/Login") || document.referrer.includes("/Login?"));
    if (isRequestAfterLogin) {
        return false;
    }

    const lastTimeShown = getLastShownFromLocalStorage();
    const wasNeverShown = lastTimeShown == null;

    const currentDateTime = moment().format("DD/MM/YYYY HH:mm:ss");
    const howLongAgoShownInMinutes = moment(currentDateTime, "DD/MM/YYYY HH:mm:ss").diff(lastTimeShown, 'minutes');

    if (wasNeverShown || howLongAgoShownInMinutes >= 5) {
        var referenceRequestTiming = getReferenceRequestTiming()
        setRequestTimingInLocalStorage(referenceRequestTiming);

        return IsMedianRequestTimingHigh();
    }

    return false;
}

function getReferenceRequestTiming() {
    var requestTimingInMs = 0;
    var momentBeforeRequestTiming;

    $.ajax({
        url: Benner.Page.getApplicationPath() + 'ping',
        contentType: "text/html",
        type: 'GET',
        cache: false,
        async: false,
        beforeSend: function () {
            var beforeRequestTiming = moment().format("DD/MM/YYYY HH:mm:ss.SSS");
            momentBeforeRequestTiming = moment(beforeRequestTiming, "DD/MM/YYYY HH:mm:ss.SSS")
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('Erro na requisição de Teste de Performance:', textStatus, errorThrown);
            requestTimingInMs = -1;
        },
        success: function (data) {
            var currentRequestTiming = moment().format("DD/MM/YYYY HH:mm:ss.SSS");
            requestTimingInMs = moment(currentRequestTiming, "DD/MM/YYYY HH:mm:ss.SSS").diff(momentBeforeRequestTiming, 'milliseconds');
        },
    });

    return requestTimingInMs;
}

function IsMedianRequestTimingHigh() {
    var median = getRequestTimingMedian();
    if (median == -1) {
        return false;
    }

    return median >= 200
}

function getRequestTimingMedian() {
    var requestTimings = getRequestTimingsFromLocalStorage();
    if (requestTimings.length < ANALYSIS_REQUEST_NUMBER)
        return -1;

    requestTimings.sort((a, b) => a - b);
    var half = Math.floor(requestTimings.length / 2);

    return requestTimings.length % 2
        ? (requestTimings[half - 1] + requestTimings[half]) / 2.0
        : requestTimings[half];
} 

function setLastShownInLocalStorage() {
    const currentDateTime = moment().format("DD/MM/YYYY HH:mm:ss");
    localStorage.setItem(LAST_ALERT_SHOWN_LOCALSTORAGE_KEY + Benner.Page.systemName, currentDateTime);
};

function getLastShownFromLocalStorage() {
    var rawDateTime = localStorage.getItem(LAST_ALERT_SHOWN_LOCALSTORAGE_KEY + Benner.Page.systemName);
    return rawDateTime == null ? null : moment(rawDateTime, "DD/MM/YYYY HH:mm:ss")
};

function setRequestTimingInLocalStorage(timing) {
    var timingList = getRequestTimingsFromLocalStorage();
    timingList.push(timing);
    timingList = timingList.slice(-ANALYSIS_REQUEST_NUMBER);

    localStorage.setItem(REQUEST_TIMINGS_LOCALSTORAGE_KEY + Benner.Page.systemName, JSON.stringify(timingList));
}

function getRequestTimingsFromLocalStorage() {
    var rawArray = localStorage.getItem(REQUEST_TIMINGS_LOCALSTORAGE_KEY + Benner.Page.systemName);
    return rawArray == null ? [] : JSON.parse(rawArray);
}

function clearRequestTimingsFromLocalStorage() {
    localStorage.removeItem(REQUEST_TIMINGS_LOCALSTORAGE_KEY + Benner.Page.systemName);
}

export default PageConnectionMonitor;
